function optionalRecord(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : undefined;
}

function stableString(value) {
  return String(value || '').trim();
}

function mergeRecords(...values) {
  const merged = {};
  for (const value of values) {
    const record = optionalRecord(value);
    if (record) Object.assign(merged, record);
  }
  return Object.keys(merged).length > 0 ? merged : undefined;
}

function mergeActionInputs(...values) {
  const merged = {};
  for (const value of values) {
    const record = optionalRecord(value);
    if (!record) continue;
    for (const [actionId, defaults] of Object.entries(record)) {
      const existing = optionalRecord(merged[actionId]);
      const next = optionalRecord(defaults);
      merged[actionId] = existing && next ? { ...existing, ...next } : defaults;
    }
  }
  return Object.keys(merged).length > 0 ? merged : undefined;
}

export function buildCreateWorkflowFromActionPlanPayload(input = {}) {
  const actionPlan = optionalRecord(input.actionPlan);
  if (!actionPlan) throw new Error('workflow action plan is required.');

  const idempotencyKey = stableString(
    input.idempotencyKey ||
      input.idempotency_key ||
      actionPlan.idempotency_key ||
      actionPlan.idempotencyKey
  );
  if (!idempotencyKey) throw new Error('workflow action-plan idempotency key is required.');

  const {
    idempotency_key: _sourceSnakeIdempotencyKey,
    idempotencyKey: _sourceCamelIdempotencyKey,
    ...actionPlanBody
  } = actionPlan;

  const body = {
    ...actionPlanBody,
    idempotency_key: idempotencyKey,
  };
  const templateName = stableString(input.templateName || input.template_name);
  const templateMetadata = mergeRecords(actionPlan.metadata, actionPlan.templateMetadata, input.templateMetadata);
  const runtimeContext = mergeRecords(actionPlan.runtime_context, actionPlan.runtimeContext, input.runtimeContext);
  const actionInputDefaults = mergeActionInputs(
    actionPlan.action_input_defaults,
    actionPlan.actionInputDefaults,
    input.actionInputDefaults
  );

  if (templateName) body.templateName = templateName;
  if (templateMetadata) body.templateMetadata = templateMetadata;
  if (runtimeContext) body.runtimeContext = runtimeContext;
  if (actionInputDefaults) body.actionInputDefaults = actionInputDefaults;
  return body;
}

export function buildWorkflowActionPlanExecutionPayload(input = {}) {
  const runtimeContext = mergeRecords(input.runtime_context, input.runtimeContext);
  const actionInputs = mergeActionInputs(input.action_inputs, input.actionInputs);
  const workflowInput = {};
  const payload = {};

  if (runtimeContext) workflowInput.runtime_context = runtimeContext;
  if (actionInputs) workflowInput.action_inputs = actionInputs;
  payload.input = workflowInput;

  if (stableString(input.delay)) payload.delay = stableString(input.delay);
  if (optionalRecord(input.resolverInputs)) payload.resolverInputs = input.resolverInputs;
  if (optionalRecord(input.resolver_inputs)) payload.resolverInputs = input.resolver_inputs;
  if (input.workspaceId !== undefined) payload.workspaceId = input.workspaceId;
  if (input.agentId !== undefined) payload.agentId = input.agentId;
  if (input.workspaceContextAvailable !== undefined) {
    payload.workspaceContextAvailable = input.workspaceContextAvailable;
  }
  if (Array.isArray(input.availableMcps)) payload.availableMcps = input.availableMcps;

  return payload;
}
